// extracted by mini-css-extract-plugin
export default {"image":"Title_image__bavUb","title":"Title_title__oEFuL","label":"Title_label__-Tr-i","children":"Title_children__ixvG5","subTitle":"Title_subTitle__ik0la"};